import { getAccountAccessLevel } from '@/store/account/actions';
import { AccessLevel } from '@dev/ee-api/ee-api-models';
import { useSelector } from 'react-redux';

export const useAccessLevel = () => {
    const currentAccessLevel = useSelector(getAccountAccessLevel);

    const hasAccessLevel = (...accessToCheck: AccessLevel[]) =>
        accessToCheck.every((access: AccessLevel) => currentAccessLevel?.includes(access));

    return { hasAccessLevel };
};
